module.exports = __webpack_public_path__ + "img/tarik_komisi.142932d5.png";